import React, {Component} from 'react';
import Api from "../../utils/Api";
import moment from 'moment';
import StaticFunctions from "../../utils/StaticFunctions";
import CheckBoxField from "../../utils/CheckBoxField";
import CSVDownloadButton from "../../utils/CSVDownloadButton";
import PDFDownloadButton from "../../utils/PDFDownloadButton";
import DOMDownloadButton from "../../utils/DOMDownloadButton";
import TimerangeSelector from "../../globalComponents/TimerangeSelector";
import MachineSelector from "../../globalComponents/MachineSelector";
import BiaxialBarChart from "../../utils/charts/BiaxialBarChart";
import TimeRange from "../../utils/TimeRange";
import ShiftSelector from "../../globalComponents/ShiftSelector";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import TableContainer from "../../utils/TableContainer";
import domtoimage from "dom-to-image";

import "../../css/style-chart.css";

class ReportStitches extends Component {
    /*
        static propTypes = {
            baseData: PropTypes.object.isRequired,
            machines: PropTypes.instanceOf(Machines).isRequired,
        };
    */
    constructor(props) {

        super(props);

        this.api = new Api();

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);
        this.saveSettings = this.props.baseData.saveSettings;
        this.resizeTimer = null;

        this.state = {
            reportStatus: null,
            reportParams: null,
            timeRange: null, // TimeRange
            showSubThreadbreaks: false,
            selectedMachine: null,
            selectedShift: null,
            currentCompanyId: props.baseData.companies.currentCompany ? props.baseData.companies.currentCompany.id : null,
            requestedParams: null, // stringified parameters to prevent double-request
            chartAreaWidth: 800,
            chartData: null, // chartdata from server
            charts: this.getDefaultChartSet(),
            errorData: null,
            pdfChartUrls: null
        };

        this.reportKey = 'stitchesAndThreadbreaks';

        this.chartClicked = this.chartClicked.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
        this.requestReport = this.requestReport.bind(this);
        this.requestNextReport = this.requestNextReport.bind(this);
        this.requestPdfContent = this.requestPdfContent.bind(this);
        this.timerangeChanged = this.timerangeChanged.bind(this);
        this.machineSelected = this.machineSelected.bind(this);
        this.reportResult = this.reportResult.bind(this);
        this.reportNextResult = this.reportNextResult.bind(this);
        this.shiftSelected = this.shiftSelected.bind(this);
        this.toggleCheckBox = this.toggleCheckBox.bind(this);
        this.getEmptyChartData = this.getEmptyChartData.bind(this);
        this.getPdfContent = this.getPdfContent.bind(this);

    }

    componentWillMount() {

        const newState = {};

        // Timerange aus den userprops laden
        const tr = new TimeRange();
        const momentYesterday = moment().add(-1, 'days');

        tr.setRange(momentYesterday.clone().startOf('day'), momentYesterday.clone().endOf('day'));

        if (tr && tr.isValid()) newState.timeRange = tr;

        // Machines aus den userprops laden
        const machine = this.getReportSetting('machine');

        if (machine) {
            const parseMachine = JSON.parse(machine);

            if (parseMachine.value !== 'all') newState.selectedMachine = parseMachine;
        }

        // Shift aus den userprops laden
        const sid = this.getReportSetting('shiftId');

        if (sid) {
            let shift = this.props.baseData.shifts.getShiftById(sid);

            if (shift) newState.selectedShift = shift;
        }

        // ShowSubThreadbreaks aus den userprops laden
        const showSubThreadbreaks = this.getReportSetting('showSubThreadbreaks', false);

        if (showSubThreadbreaks) newState.showSubThreadbreaks = true;

        if (newState) this.setState(newState);

    }

    componentDidMount() {

        this.updateDimensions();

        window.addEventListener("resize", this.updateDimensions);

    }

    componentWillUnmount() {

        window.removeEventListener("resize", this.updateDimensions);

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.baseData.companies && nextProps.baseData.companies.currentCompany) {
            if (nextProps.baseData.companies.currentCompany.id !== this.state.currentCompanyId) {
                this.setState({
                    selectedMachine: null,
                    currentCompanyId: nextProps.baseData.companies.currentCompany.id,
                    chartData: null,
                    charts: this.getDefaultChartSet(),
                });
            }
        }

    }

    getReportSetting(key, defaultValue = null) {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const reportSettings = (settings.hasOwnProperty('reports') && settings.reports.hasOwnProperty(this.reportKey)) ? settings.reports[this.reportKey] : {};

        return (reportSettings.hasOwnProperty(key)) ? reportSettings[key] : defaultValue;

    }

    updateDimensions() {

        let adjust = () => {
            try {
                this.resizeTimer = 0;
                // try to adjust chart width
                let newWidth = this.chartArea.offsetWidth > 300 ? this.chartArea.offsetWidth : 300;

                if (newWidth !== this.state.chartAreaWidth) this.setState({chartAreaWidth: newWidth});
            } catch (e) {
            }
        };

        if (this.resizeTimer === null) adjust();

        if (this.resizeTimer > 0) window.clearTimeout(this.resizeTimer);

        this.resizeTimer = window.setTimeout(adjust, 75);

    }

    getRequestParams() {

        const tr = this.state.timeRange;
        const gran = tr ? tr.getDisplayGranularity() : null;
        const dateFrom = tr ? tr.getFromMoment() : null;
        const dateTill = tr ? tr.getTillMoment() : null;
        const machineId = this.state.selectedMachine ? this.state.selectedMachine.value : null;

        // Check, if all data is set
        if (!dateFrom || !dateTill || !gran || !machineId) return null;
        if (!dateFrom.isValid() || !dateTill.isValid()) return null;

        return {
            machine: machineId,
            id_company: this.props.baseData.companies.currentCompany.id,
            from: dateFrom.unix(),
            till: dateTill.unix(),
            showSubThreadbreaks: this.state.showSubThreadbreaks,
            shift: this.state.selectedShift ? this.state.selectedShift.getRange() : null,
            timezone: this.props.baseData.companies.currentCompany.timezone,
            interval: gran.interval,
        };

    }

    requestReport() {

        if (this.state.reportStatus === 'requested') return null;

        const params = this.getRequestParams();

        if (params === null) return null;

        const sParams = JSON.stringify(params);

        if (sParams === this.state.requestedParams) return null;

        const {reportParams, ...newReportParams} = {...this.state};

        const error = function(error) {
            if (error) {
                this.setState({
                    reportStatus: 'error',
                    chartData: null,
                    errorData: error,
                });
            }
        }.bind(this);

        this.setState({
            reportStatus: 'requested',
            reportParams: newReportParams,
            requestedParams: sParams,
            charts: this.getDefaultChartSet(),
            errorData: null,
            pdfChartUrls: null,
        }, () => {
            this.api.request('GetStitchHistory', params, this.reportResult, error);
            this.createEmptyChart(this.state.reportParams.timeRange);
        });

    }

    requestNextReport(tr, interval) {

        if (!interval) return null;

        const dateFrom = tr ? tr.getFromMoment() : null;
        const dateTill = tr ? tr.getTillMoment() : null;
        const gran = tr.getDisplayGranularity();
        const machineId = this.state.selectedMachine ? this.state.selectedMachine.value : null;

        if (!dateFrom || !dateTill || !machineId) return null;
        if (!dateFrom.isValid() || !dateTill.isValid()) return null;

        const params = {
            machine: machineId,
            id_company: this.props.baseData.companies.currentCompany.id,
            from: dateFrom.unix(),
            till: dateTill.unix(),
            showSubThreadbreaks: this.state.showSubThreadbreaks,
            shift: this.state.selectedShift ? this.state.selectedShift.getRange() : null,
            timezone: this.props.baseData.companies.currentCompany.timezone,
            interval: gran.interval
        };

        const charts = [...this.state.charts];

        for (let ix in charts) {
            let chart = charts[ix];

            if (chart.chartKey === interval) {
                charts[ix] = {
                    status: 'waiting',
                    timeRange: tr,
                    chartData: this.getEmptyChartData(tr),
                    chartKey: interval,
                    unit: gran.unit,
                    translationKey: gran.translationKey,
                };
            }
        }

        this.setState({
            charts: charts,
        }, () => {
            this.api.request('GetStitchHistory', params, this.reportNextResult, null);
        });

    }

    requestPdfContent() {

        const filledCharts = this.getFilledCharts();
        const pdfCharts = [];

        window.setTimeout(() => {
            filledCharts.forEach(
                (chartData, index) => {
                    let domElement = document.getElementById('chart-' + chartData.chartKey);

                    if (domElement) {
                        domtoimage.toPng(domElement).then((dataUrl) => {
                            pdfCharts[index] = dataUrl;

                            if (pdfCharts.length === filledCharts.length) {
                                this.setState({
                                    pdfChartUrls: (pdfCharts.length > 0) ? pdfCharts : null
                                });
                            }
                        });
                    }
                }
            );
        }, 1000);

    }

    getDefaultChartSet() {

        return [
            {status: null, timeRange: null, chartData: null, unit: null, translationKey: null, chartKey: 'years'},
            {status: null, timeRange: null, chartData: null, unit: null, translationKey: null, chartKey: 'months'},
            {status: null, timeRange: null, chartData: null, unit: null, translationKey: null, chartKey: 'days'},
            {status: null, timeRange: null, chartData: null, unit: null, translationKey: null, chartKey: 'hours'},
            {status: null, timeRange: null, chartData: null, unit: null, translationKey: null, chartKey: 'minutes'},
        ];

    }

    timerangeChanged(newRange) {

        if (newRange && (newRange instanceof TimeRange) && newRange.isValid()) {
            this.setState({
                timeRange: newRange,
            });

            // Safe Timerange to Userconfig
            if (this.saveSettings) {
                this.saveSettings('reports', {report: this.reportKey, key: 'timeRange', value: newRange.serialize()});
            }
        }

    }

    machineSelected(machine) {

        this.setState({
            selectedMachine: machine
        });

        // Safe Machine to Userconfig
        if (this.saveSettings && machine) {
            this.saveSettings('reports', {report: this.reportKey, key: 'machine', value: JSON.stringify(machine)});
        }

    }

    shiftSelected(shift) {

        this.setState({
            selectedShift: shift
        });

        // Safe Shift-id to Userconfig
        if (this.saveSettings && shift) {
            this.saveSettings('reports', {report: this.reportKey, key: 'shiftId', value: shift.id});
        }

    }

    toggleCheckBox(fieldName, isChecked) {

        const state = {...this.state};

        state[fieldName] = isChecked;

        this.setState(state);

        // Safe option to Userconfig
        if (this.saveSettings && isChecked !== null) {
            this.saveSettings('reports', {report: this.reportKey, key: fieldName, value: isChecked});
        }

    }

    reportResult(result) {

        // Result-Daten in Grid einsortieren
        let currentGrid = this.state.chartData;
        let tr = this.state.timeRange;
        let gran = tr.getDisplayGranularity();

        // Create a new grid with new objects to avoid mutation of read-only state
        let grid = currentGrid.map(row => ({...row}));

        for (let ix in result) {
            let resMoment = moment(ix, 'X').format(gran.label);

            for (let ix2 in grid) {
                let dataRow = grid[ix2];

                if (dataRow.name === resMoment) {
                    let resultRow = result[ix];

                    dataRow.st += resultRow.st;
                    dataRow.tb += resultRow.tb;
                    break;
                }
            }
        }

        let charts = [...this.state.charts];

        for (let ix3 in charts) {
            let chart = charts[ix3];

            if (chart.chartKey === gran.interval) {
                charts[ix3].status= 'filled';
                charts[ix3].timeRange= tr;
                charts[ix3].chartData = grid;
                charts[ix3].unit = gran.unit;
                charts[ix3].translationKey = gran.translationKey;
            }
        }

        this.setState({
            reportStatus: 'ready',
            chartData: grid,
            charts: charts,
        }, () => {
            this.requestPdfContent();
        });

    }

    reportNextResult(result) {

        const charts = [...this.state.charts];

        let grid = [];
        let gran = null;
        let waitingFound = false;
        let waitingIndex = -1;

        for (let ix in charts) {
            let chart = charts[ix];

            if (chart.status === 'waiting') {
                // Create a new grid with new objects to avoid mutation
                grid = charts[ix].chartData.map(row => ({...row}));
                gran = charts[ix].timeRange.getDisplayGranularity();
                waitingIndex = ix;
                break;
            }
        }

        if (gran && waitingIndex !== -1) {
            for (let ix in result) {
                let resMoment = moment(ix, 'X').format(gran.label);

                for (let ix2 in grid) {
                    let dataRow = grid[ix2];

                    if (dataRow.name === resMoment) {
                        let resultRow = result[ix];

                        dataRow.st += resultRow.st;
                        dataRow.tb += resultRow.tb;
                        break;
                    }
                }
            }

            for (let ix2 in charts) {
                let chart = charts[ix2];

                if (ix2 === waitingIndex) {
                    charts[ix2].status= 'filled';
                    charts[ix2].chartData = grid;

                    waitingFound = true;
                } else {
                    if (waitingFound) {
                        charts[ix2].status= null;
                        charts[ix2].chartData = null;
                        charts[ix2].timeRange = null;
                        charts[ix2].unit = gran.unit;
                        charts[ix2].translationKey = gran.translationKey;
                    }
                }
            }

            this.setState({
                charts: charts,
            }, () => {
                this.requestPdfContent();
            });
        }

    }

    // Aktuelles Chart mit leeren Werten fuellen
    createEmptyChart(timeRange) {

        const gran = timeRange ? timeRange.getDisplayGranularity() : null;
        const till = timeRange.getTillMoment().unix();

        let t = moment(timeRange.getFromMoment(), 'X');
        let grid = [];

        while (true) {
            grid.push({
                name: t.format(gran.label), format: gran.label, realDate: t.format(gran.realDate), realDateFormat: gran.realDate, st: 0, tb: 0
            });

            t = t.add(gran.duration);

            if (t.unix() > till) break;
        }

        this.setState({
            chartData: grid,
            charts: this.getDefaultChartSet(),
        });

    }

    getEmptyChartData(timeRange) {

        const gran = timeRange ? timeRange.getDisplayGranularity() : null;
        const till = timeRange.getTillMoment().unix();

        let t = moment(timeRange.getFromMoment(), 'X');
        let grid = [];

        while (true) {
            grid.push({
                name: t.format(gran.label), format: gran.label, realDate: t.format(gran.realDate), realDateFormat: gran.realDate, st: 0, tb: 0
            });

            t = t.add(gran.duration);

            if (t.unix() > till) break;
        }

        return grid;

    }

    chartClicked(activeIndex, key) {

        const charts = this.state.charts;
        let chart = null;

        for (let ix in charts) {
            if (charts[ix].chartKey === key) {
                chart = charts[ix];
                break;
            }
        }

        if (!chart || !chart.chartData || !chart.chartData[activeIndex]) return null;

        const payload = chart.chartData[activeIndex];
        const realDate = payload.realDate;
        const realDateFormat = payload.realDateFormat;

        let drillDownKey = 'day';
        console.debug("payload", payload);

        if (payload.format === 'YYYY') {
            drillDownKey = 'year';
        } else if (payload.format === 'MM.YYYY') {
            drillDownKey = 'month';
        } else if (payload.format === 'DD.MM.YYYY') {
            drillDownKey = 'day';
        } else if (payload.format === 'DD[T-]HH[h]' || payload.format === 'HH') {
            drillDownKey = 'hour';
        }

        const startDate = moment(realDate, realDateFormat).startOf(drillDownKey);
        const endDate = moment(realDate, realDateFormat).endOf(drillDownKey);
        const tr = new TimeRange().setRange(startDate, endDate);
        const gran = tr.getDisplayGranularity();

        // If granularity didn't change (e.g. click on a day in a day-view), try to go one level deeper
        let nextInterval = gran.interval;
        if (nextInterval === key) {
            if (key === 'years') nextInterval = 'months';
            else if (key === 'months') nextInterval = 'days';
            else if (key === 'days') nextInterval = 'hours';
            else if (key === 'hours') nextInterval = 'minutes';
        }

        this.requestNextReport(tr, nextInterval);

    }

    getErrorBlock() {

        let errorBlock = null;

        if (this.state.errorData || this.state.reportStatus === 'error') {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('errorOccured')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isValid()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsUnset')}</span>;
        } else if (!this.state.reportParams.timeRange.isNotInFuture()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsInFuture')}</span>;
        } else if (this.state.reportParams.selectedMachine === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('machineIsUnset')}</span>;
        } else if (this.state.chartData === null) {
            errorBlock = <LoadingSplash color={'dark'}/>;
        } else if (this.state.chartData && this.state.chartData.length === 0) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('noDataFound')}</span>;
        }

        return (errorBlock !== null) ? errorBlock : null;

    }

    getChartHeadline(timeRange, otherParams = {}) {

        const params = {
            machine: this.state.reportParams.selectedMachine,
            machineTitle: this.translate('machine'),
            allMachinesTitle: this.translate('allMachines'),
            design: this.state.reportParams.selectedDesign,
            designTitle: this.translate('design'),
            allDesignsTitle: this.translate('allDesigns'),
            timerange: timeRange,
            formatedDate: this.timeFormats.fullDate,
            timerangeTitle: this.translate('timerange'),
            shift: this.state.reportParams.selectedShift,
            shiftTitle: this.translate('shift'),
            groupingOpt: this.groupingOpt,
            groupingId: this.state.reportParams.selectedGrouping,
            groupingTitle: this.translate('grouping')
        };

        return StaticFunctions.createReportHeadlineFromParams({...params, ...otherParams});

    }

    getChartBlock(timeRange, chartData, chartUnit, chartKey) {

        if (!(timeRange && chartData && chartUnit)) return null;

        const headlineParts = timeRange.getDisplayHeadline(this.timeFormats.fullDate);
        const headline = this.getChartHeadline(timeRange, {
            fixTimerange: headlineParts.range,
            overview: this.translate(chartKey),
            overviewTitle: this.translate('overview')
        });
        const drillDownActive = (chartKey !== 'minutes');

        return (
            <div id={'chart-' + chartKey}>
                <nav>
                    <h1>{headline}</h1>
                </nav>

                <div className="chartBox">
                    <BiaxialBarChart
                        chartKey={chartKey}
                        data={chartData}
                        label1={this.translate('stitches')}
                        label2={this.translate('threadbreaks')}
                        translate={this.translate}
                        width={1700}
                        drillDown={drillDownActive}
                        handleClick={this.chartClicked}
                    />
                </div>
            </div>
        );

    }

    generateChart() {

        const errorBlock = this.getErrorBlock();

        if (errorBlock !== null) return null;
        if (!this.state.reportParams) return null;

        const charts = this.state.charts.map(
            (data, index) => {
                return (
                    <div key={'chart-' + data.chartKey}>
                        {this.getChartBlock(data.timeRange, data.chartData, data.unit, data.chartKey)}
                    </div>
                );
            }
        );

        if (charts.length === 0) return null;

        return (
            <div id="chartArea" className="ma-bo-10">
                {charts}
            </div>
        );

    }

    generateTable() {

        const errorBlock = this.getErrorBlock();

        if (errorBlock !== null) return null;

        const tableData = this.getTableData();

        if (!tableData) return null;

        return (
            <div id="tableArea" className="ma-bo-10">
                <TableContainer
                    baseData={this.props.baseData}
                    columns={tableData.tableColumns}
                    rows={tableData.tableRows}
                    maxWidth={700}
                />
            </div>
        );

    }

    getTableData() {

        const filledCharts = this.getFilledCharts();

        if (filledCharts.length === 0) return null;

        const tableData = filledCharts[filledCharts.length - 1];

        return {
            tableColumns: this.getTableColumns(tableData.translationKey),
            tableRows: this.getTableRows(tableData.chartData)
        };

    }

    getFilledCharts() {

        const charts = this.state.charts;

        let filledCharts = [];

        for (let ix in charts) {
            let chart = charts[ix];

            if (chart.status === 'filled') filledCharts.push(chart);
        }

        return filledCharts;

    }

    getCsvContent() {

        const csvContent = {
            csvTitle: [],
            csvColumns: [],
            csvData: []
        };

        if (this.state.reportStatus === 'ready') {
            const format = this.timeFormats.fullDate;
            const charts = (this.state.charts) ? this.state.charts : [];

            charts.forEach(
                (chart) => {
                    if (chart.status === 'filled') {
                        csvContent.csvTitle.push(this.getChartHeadline(chart.timeRange, {
                            fixTimerange: chart.timeRange.getDisplayHeadline(format).range,
                            overview: this.translate(chart.chartKey),
                            overviewTitle: this.translate('overview')
                        }));
                        csvContent.csvColumns.push(this.getTableColumns(chart.translationKey));
                        csvContent.csvData.push(this.getTableRows(chart.chartData));
                    }
                }
            );
        }

        return csvContent;

    }

    getPdfContent() {

        const tableData = this.getTableData();

        return {
            charts: (this.state.pdfChartUrls) ? this.state.pdfChartUrls : null,
            orientation: 'L',
            tableColumns: (tableData) ? tableData.tableColumns : null,
            tableRows: (tableData) ? tableData.tableRows : null
        };

    }

    getTableColumns(timerangeKey = null) {

        return [
            {
                key: 'name',
                nameKey: (timerangeKey) ? timerangeKey : 'label',
                sortType: 'string',
            },
            {
                key: 'st',
                nameKey: 'stitches',
                classes: 'text-right',
                sortType: 'string',
            },
            {
                key: 'tb',
                nameKey: 'threadbreaks',
                classes: 'text-right',
                sortType: 'string',
            },
            {
                key: 'threadBreaksPer10KStiches',
                nameKey: 'threadBreaksPer10KStiches',
                classes: 'text-right',
                sortType: 'string',
            },
        ];

    }

    getTableRows(data) {

        const rows = [];

        let sumSt = 0;
        let sumTb = 0;

        if (data) {
            data.forEach(
                (row, index) => {
                    sumSt += row.st;
                    sumTb += row.tb;

                    rows.push({
                        id: index,
                        name: row.name,
                        st: StaticFunctions.formatedNumber(row.st),
                        tb: StaticFunctions.formatedNumber(row.tb),
                        threadBreaksPer10KStiches: StaticFunctions.formatedNumber(StaticFunctions.calcThreadbreaksByRatio(row.st, row.tb), 2),
                    });
                }
            );
        }

        rows.push({
            id: 'sum',
            name: this.translate('sum'),
            st: StaticFunctions.formatedNumber(sumSt),
            tb: StaticFunctions.formatedNumber(sumTb),
            threadBreaksPer10KStiches: StaticFunctions.formatedNumber(StaticFunctions.calcThreadbreaksByRatio(sumSt, sumTb), 2),
        });

        return rows;

    }

    renderRequestButton() {

        const reportParams = this.getRequestParams();
        const sParams = JSON.stringify(reportParams);

        if (this.state.reportStatus === 'requested' || sParams === this.state.requestedParams) {
            return (
                <a className="prewLink disabled-link">{this.translate('requestReport')}</a>
            );
        } else {
            return (
                <a className="prewLink orangeButton" onClick={() => this.requestReport()}>{this.translate('requestReport')}</a>
            );
        }

    }

    renderDownloadButtons() {

        if (this.state.reportStatus !== 'ready' || !this.state.reportParams || this.getErrorBlock() !== null) {
            return (
                <div className="bottomLinks clearfix">
                    <div><button className="disabled-link">{this.translate('csvDownloadLabel') + ' (CSV)'}</button></div>
                    <div><button className="disabled-link">{this.translate('imageDownloadLabel') + ' (PNG)'}</button></div>
                    <div><button className="disabled-link">{this.translate('pdfDownloadLabel') + ' (PDF)'}</button></div>
                </div>
            );
        } else {
            const csvContent = this.getCsvContent();
            const pdfContent = this.getPdfContent();

            return (
                <div className="bottomLinks clearfix">
                    <CSVDownloadButton
                        baseData={this.props.baseData}
                        fileName={this.props.reportName}
                        csvTitle={csvContent.csvTitle}
                        columns={csvContent.csvColumns}
                        data={csvContent.csvData}
                    />

                    <DOMDownloadButton
                        baseData={this.props.baseData}
                        domId={'chartArea'}
                        fileName={this.props.reportName}
                    />

                    <PDFDownloadButton
                        baseData={this.props.baseData}
                        fileName={this.props.reportName}
                        charts={pdfContent.charts}
                        tableColumns={pdfContent.tableColumns}
                        tableRows={pdfContent.tableRows}
                    />
                </div>
            );
        }

    }

    renderChartArea() {

        if (this.state.reportStatus === null) return null;
        if (this.state.reportStatus === 'requested') return <LoadingSplash color={'dark'}/>;

        const errorBlock = this.getErrorBlock();

        if (errorBlock !== null) return errorBlock;

        return this.generateChart();

    }

    renderTableArea() {

        if (this.state.reportStatus === null) return null;
        if (this.state.reportStatus === 'requested') return null;

        const errorBlock = this.getErrorBlock();

        if (errorBlock !== null) return null;

        return this.generateTable();

    }

    render() {

        const timerangeFormat = this.timeFormats.fullDate;
        const chartArea = this.renderChartArea();
        const tableArea = this.renderTableArea();
        const requestButton = this.renderRequestButton();

        const downloadArea = this.renderDownloadButtons();

        return (
            <div>
                <div id="reportSettings" className="clearfix">
                    <div className="clearfix">
                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <h4>{this.translate('timerange')}</h4>

                                <div>
                                    <TimerangeSelector
                                        TimeRange={this.state.timeRange}
                                        displayFormat={timerangeFormat}
                                        translate={this.translate}
                                        onTimeRangeChanged={this.timerangeChanged}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="formSettings ma-bo-10">
                                <h4>{this.translate('machine')}</h4>

                                <div>
                                    <MachineSelector
                                        machine={this.props.machines}
                                        currentMachine={this.state.selectedMachine}
                                        translate={this.translate}
                                        onMachineSelected={(machine) => this.machineSelected(machine)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="formSettings ma-bo-10">
                                <h4>{this.translate('shift')}</h4>

                                <div>
                                    <ShiftSelector
                                        baseData={this.props.baseData}
                                        currentShift={this.state.selectedShift}
                                        onShiftSelected={(shift) => this.shiftSelected(shift)}
                                    />
                                </div>
                            </div>

                            <div className="formSettings ma-bo-10">
                                <h4>{this.translate('options')}</h4>

                                <div className="formBox">
                                    <CheckBoxField
                                        name="showSubThreadbreaks"
                                        label={this.translate('showSubThreadbreaks')}
                                        isChecked={this.state.showSubThreadbreaks}
                                        onChange={this.toggleCheckBox}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('downloadReport')}</h4>

                                {downloadArea}
                            </div>
                        </div>
                    </div>

                    <div className="bottomLinks clearfix">
                        {requestButton}
                    </div>
                </div>

                <div id="reportArea" className="clearfix">
                    <div id="chartArea" className="ma-bo-10">
                        {chartArea}
                    </div>

                    <div id="tableArea" className="ma-bo-10">
                        {tableArea}
                    </div>
                </div>
            </div>
        );

    }

}

export default ReportStitches;
